// modules/land-for-sale/elements/PlanMasterOverlay.js
import React        from 'react';

class PlanMasterOverlay extends React.Component {


	renderPolygons(element) {
		return (
			<polygon key={element.id} points={element.coords} className="landforsale-overlay-stage" />
		);
	}

	render() {
		if ((this.props.plantype === "masterplan" || this.props.plantype === "precinctplan") && this.props.elements.length > 0) {
			return (
				<div className={"landforsale-master_overlay "+this.props.plantype}>
					<svg width={this.props.width} height={this.props.height}>
						{this.props.elements.map(this.renderPolygons)}
					</svg>
				</div>
			);
		} else {
			return (<div></div>);
		}
	}
}

export default PlanMasterOverlay;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanMasterOverlay.js
 **/